import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { withAuthLang } from '@app/i18n';
import Logo from '@shared/assets/Logo';
import TabsComponent from '@shared/ui/TabsComponent';

export default function LoginHeader() {
  const activeRoute = useLocation().pathname;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tabsOptions = [
    { label: t('sign_in'), value: '/login' },
    { label: t('sign_up'), value: '/sign-up' },
  ];

  return (
    <>
      <Logo />
      <TabsComponent
        fullWidth
        options={tabsOptions}
        value={activeRoute}
        setValue={(value) => navigate(withAuthLang(value))}
      />
    </>
  );
}
